import {CustomFlatList} from '@buncha/components/core/list';
import {Divider} from 'native-base';
import {H5Text} from '@buncha/components/core/text';
import If from '@buncha/components/conditional/If';
import {ItemDetailsScreen} from '@buncha/itemDetails/navigation/types';
import {Modules} from '@buncha/utils/types';
import SimilarItemCell from './SimilarItemCell';
import {useGetLocale} from '@buncha/localization/hooks';
import {useRoute} from '@react-navigation/native';

import {ActivityIndicator, StyleSheet} from 'react-native';
import React, {useCallback, useEffect} from 'react';
import {
  RecommendedItemCell,
  ReplacementItemDetails,
} from '@buncha/itemDetails/types/itemReplacement';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';
import {
  useReplacementItemDetailsContext,
  useSimilarItemsForDescription,
} from '@buncha/itemDetails/hooks/ReplacementItemDetail';

interface RouteParamsType {
  runId?: number;
  quantity?: number;
  orderItem?: ReplacementItemDetails;
}

const SimilarItems = () => {
  const {state, dispatch} = useReplacementItemDetailsContext();
  const [similarItemsForDescription, similarData] =
    useSimilarItemsForDescription(dispatch);
  const {title} =
    useGetLocale(
      Modules.itemDetails,
      ItemDetailsScreen.ReplacementItemDetailsPage,
    ) ?? {};

  const tagLength = state.item?.tags?.length || 0;
  const route = useRoute();
  const routeParams: RouteParamsType | undefined = route?.params;
  const loadingRecommendation = similarData.loading;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  const quantityToPick = routeParams?.quantity || 0;
  const orderItem = routeParams?.orderItem;

  const storeId =
    orderItem?.order?.run?.store?.id || state.runData?.store?.id || 0;
  const similarItems = state?.similarItemsForDescription?.data;

  const similarItemsData = state?.similarItemsForDescription?.data?.length
    ? [state?.similarItemsForDescription]
    : [];

  useEffect(() => {
    const param = {
      storeId: storeId,
      from: 0,
      size: 10,
      searchQuery: state.item?.name,
      catalogItemId: state.item?.id,
      runId: state.runData?.id,
    };
    const paramWithCategory = {
      ...param,
      cat: state.item?.tags?.[0] ?? state.item?.category ?? '',
      subcat: tagLength > 1 ? state.item?.tags[1] : '',
    };
    similarItemsForDescription(paramWithCategory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderItem = useCallback(
    (subItem: {item: RecommendedItemCell}) => {
      return (
        <SimilarItemCell
          itemInfo={subItem?.item}
          quantity={quantityToPick}
          runId={routeParams?.runId}
          orderItem={orderItem}
        />
      );
    },
    [orderItem, quantityToPick, routeParams?.runId],
  );

  if (loadingRecommendation) return <ActivityIndicator style={styles.loader} />;
  return (
    <React.Fragment>
      <If condition={similarItemsData.length}>
        <H5Text
          style={[
            styles.text,
            {color: theme?.text.blue[300], fontFamily: muliFont[700].normal},
          ]}
          alignText="left">
          {title?.similarItems}
        </H5Text>
        <CustomFlatList
          scrollEnabled={true}
          horizontal={true}
          data={similarItems}
          showsHorizontalScrollIndicator={false}
          renderItem={renderItem}
        />
        <Divider />
      </If>
    </React.Fragment>
  );
};

export default React.memo(SimilarItems);

const styles = StyleSheet.create({
  seperator: {
    marginTop: 10,
    marginBottom: 20,
    marginHorizontal: -15,
    borderBottomWidth: 1,
  },
  text: {marginVertical: 10},
  loader: {marginTop: 20},
});
